{
  "gear": {
    "maxPlus": 10,
    "steps": [
      {
        "from": 0,
        "needsScroll": false,
        "successPct": 100,
        "onFail": "none",
        "gold": 500,
        "statGainPct": 5
      },
      {
        "from": 1,
        "needsScroll": false,
        "successPct": 100,
        "onFail": "none",
        "gold": 1000,
        "statGainPct": 6
      },
      {
        "from": 2,
        "needsScroll": false,
        "successPct": 90,
        "onFail": "stay",
        "gold": 2500,
        "statGainPct": 8
      },
      {
        "from": 3,
        "successPct": 75,
        "onFail": "destroy",
        "gold": 6000,
        "statGainPct": 10
      },
      {
        "from": 4,
        "successPct": 55,
        "onFail": "destroy",
        "gold": 15000,
        "statGainPct": 14
      },
      {
        "from": 5,
        "successPct": 35,
        "onFail": "destroy",
        "gold": 40000,
        "statGainPct": 18
      },
      {
        "from": 6,
        "successPct": 18,
        "onFail": "destroy",
        "gold": 100000,
        "statGainPct": 24
      },
      {
        "from": 7,
        "successPct": 12,
        "onFail": "destroy",
        "gold": 250000,
        "statGainPct": 32
      },
      {
        "from": 8,
        "successPct": 7,
        "onFail": "destroy",
        "gold": 500000,
        "statGainPct": 42
      },
      {
        "from": 9,
        "successPct": 4,
        "onFail": "destroy",
        "gold": 1000000,
        "statGainPct": 55
      }
    ]
  },
  "jewelry": {
    "maxPlus": 3,
    "copies": 3,
    "steps": [
      {
        "from": 0,
        "gold": 2000,
        "statGainPct": 8
      },
      {
        "from": 1,
        "gold": 6000,
        "statGainPct": 10
      },
      {
        "from": 2,
        "gold": 15000,
        "statGainPct": 14
      }
    ]
  },
  "fortuneMult": 1.5
}
